import gtm from 'eco-design-reliance/gtm';
import { ItfGTM81Entire, ItfGTM81 } from './type';

// https://docs.google.com/spreadsheets/d/11MquSBS3Lo7WJsZg_bbcDfNOefHKrr0P_YgD7qeBGFQ/edit?pli=1&gid=370435365#gid=370435365
// 【No4.用户行为】Sheet
export const handle_GTM_81 = (data: ItfGTM81) => {
    gtm.push({ ...data, event: 'uaEvent', event_name: 'pop_ups' } as ItfGTM81Entire);
};
